export default [
    {
        path: '/ambience/panel',
        name: 'ambience-panel',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Painel de Ambientes',
            icon: 'mdi-domain',
            breadcrumbs: [
                { text: 'Painel de Ambientes', disabled: true }
            ]
        }
    }
]
